// ZZYON NextDay — main entry. Vite + vanilla JS.
// Onda 1: login + dashboard Operação ao Vivo (NFs em aberto)

import './styles.css';
import './nd-logo.js';
import {
  ndAuth, isIcaroEmail, signInMagic, signOut, getCurrentUser,
  fetchKpis, fetchNfsEmAberto,
  reconciliarEmAberto, fetchReconciliacaoLog,
  calcularFechamento, salvarFechamento, fetchFechamentos, fetchFechamento,
} from './nd-client.js';
import {
  fmtBRL, fmtNum, fmtDate, fmtDateTime, escapeHtml,
  diasBadge, valorRiscoBadge,
} from './utils.js';

const $ = (sel, root = document) => root.querySelector(sel);

// ─── Bootstrap ─────────────────────────────────────────────
async function boot() {
  ndAuth.auth.onAuthStateChange((event) => {
    if (event === 'SIGNED_IN' || event === 'SIGNED_OUT' || event === 'TOKEN_REFRESHED') {
      route();
    }
  });
  await route();
  window.addEventListener('hashchange', route);
}

async function route() {
  const user = await getCurrentUser();
  if (!user) return renderLogin();
  if (user.email && !isIcaroEmail(user.email)) return renderBlocked(user.email);
  const tab = (location.hash.slice(1) || 'operacao').split('/')[0];
  renderShell(user, tab);
}

// ─── Login ────────────────────────────────────────────────
function renderLogin() {
  $('#app').innerHTML = `
    <div class="nd-login-wrap">
      <div class="nd-login-card">
        <div style="display:flex;justify-content:center;margin-bottom:22px;color:#fff">
          <nd-logo size="56" sub="true"></nd-logo>
        </div>
        <div class="nd-login-eyebrow">Plataforma operacional</div>
        <h1>Fechamento e gestão NextDay</h1>
        <div class="tagline">Operação W-HOUSE · Whirlpool / MLOG · São Paulo</div>

        <input id="nd-email" type="email" autocomplete="email"
               placeholder="seu.nome@icaroexpress.com"
               class="nd-input" />
        <button id="nd-login-btn" class="nd-btn">Receber link de acesso</button>
        <div id="nd-msg" class="nd-msg"></div>

        <div class="nd-foot">
          Apenas e-mails <strong>@icaroexpress.com</strong> têm acesso.<br>
          Em caso de dúvida, fale com TI.
        </div>
      </div>
    </div>
  `;

  $('#nd-login-btn').addEventListener('click', loginHandler);
  $('#nd-email').addEventListener('keydown', e => { if (e.key === 'Enter') loginHandler(); });
}

async function loginHandler() {
  const email = $('#nd-email').value.trim();
  const msg = $('#nd-msg');
  msg.className = 'nd-msg'; msg.textContent = '';
  if (!email)              { msg.textContent = 'Informe um e-mail.'; msg.classList.add('err'); return; }
  if (!isIcaroEmail(email)){ msg.textContent = 'Apenas @icaroexpress.com.'; msg.classList.add('err'); return; }
  $('#nd-login-btn').disabled = true;
  try {
    await signInMagic(email, location.origin);
    msg.textContent = 'Link enviado! Verifique seu e-mail.';
    msg.classList.add('ok');
  } catch (err) {
    msg.textContent = 'Erro: ' + (err.message || err);
    msg.classList.add('err');
  } finally {
    $('#nd-login-btn').disabled = false;
  }
}

function renderBlocked(email) {
  $('#app').innerHTML = `
    <div class="nd-login-wrap">
      <div class="nd-login-card">
        <div style="display:flex;justify-content:center;margin-bottom:22px;color:#fff">
          <nd-logo size="48" sub="true"></nd-logo>
        </div>
        <div class="nd-login-eyebrow">Acesso restrito</div>
        <h1>Domínio não autorizado</h1>
        <div class="tagline">${escapeHtml(email)}</div>
        <p style="font-size:13px;color:rgba(255,255,255,0.7);margin:20px 0">
          ZZYON NextDay é restrito a usuários com e-mail
          <strong>@icaroexpress.com</strong>. Você está logado com outro domínio.
        </p>
        <button id="nd-signout" class="nd-btn">Sair e tentar novamente</button>
      </div>
    </div>
  `;
  $('#nd-signout').addEventListener('click', async () => { await signOut(); route(); });
}

// ─── Shell ─────────────────────────────────────────────────
const TABS = [
  { id: 'operacao',   label: 'Operação ao Vivo' },
  { id: 'historico',  label: 'Histórico de Conciliações' },
  { id: 'fechamento', label: 'Fechamento Mensal' },
  { id: 'reentregas', label: 'Reentregas' },
  { id: 'diesel',     label: 'Diesel & Reajustes' },
  { id: 'auditoria',  label: 'Auditoria' },
];

function renderShell(user, tab) {
  const navHtml = TABS.map(t => `
    <a href="#${t.id}" class="${t.id === tab ? 'active' : ''}">${t.label}</a>
  `).join('');

  $('#app').innerHTML = `
    <div class="nd-shell">
      <aside class="nd-side">
        <div class="nd-side-brand" style="color:#fff">
          <nd-logo size="32" sub="true"></nd-logo>
        </div>
        <nav class="nd-side-nav">${navHtml}</nav>
        <div class="nd-side-foot">
          ${escapeHtml(user.email)}
          <button id="nd-signout">Sair</button>
        </div>
      </aside>
      <main class="nd-main" id="nd-content">
        <div class="nd-loading">Carregando…</div>
      </main>
    </div>
  `;
  $('#nd-signout').addEventListener('click', async () => { await signOut(); route(); });

  if (tab === 'operacao')        renderOperacao();
  else if (tab === 'historico')  renderHistorico();
  else if (tab === 'fechamento') renderFechamento();
  else if (tab === 'reentregas') renderEmConstrucao('Reentregas', 'Pipeline da cobrança 60% Super Rápida com diesel aplicado por mês. Onda 3.');
  else if (tab === 'diesel')     renderEmConstrucao('Diesel & Reajustes', 'Calendário das 4 parcelas Abr-Jul/2026, gatilho 10%, cláusula de estorno. Onda 3.');
  else if (tab === 'auditoria')  renderEmConstrucao('Auditoria', 'Comparação banco vs cobrado, NFs órfãs, reconciliação manifesto W-HOUSE × ESL × FAT_JC. Onda 4.');
}

// ─── Histórico de Conciliações ────────────────────────────
async function renderHistorico() {
  $('#nd-content').innerHTML = `
    <div class="nd-page-header">
      <div class="nd-page-eyebrow">Auditoria · automação</div>
      <h1 class="nd-page-title">Histórico de Conciliações</h1>
      <div class="nd-page-sub">
        Toda baixa de NF (manual, automática via trigger ETL ou cron diário 06:30 BRT) é registrada aqui.
      </div>
    </div>
    <div id="nd-hist-area"><div class="nd-loading">Carregando…</div></div>
  `;
  try {
    const log = await fetchReconciliacaoLog({ limit: 100 });
    const aplicados = log.filter(l => l.modo === 'aplicado');
    const totalNfs   = aplicados.reduce((a,l) => a + (l.qtd_nfs || 0), 0);
    const totalValor = aplicados.reduce((a,l) => a + Number(l.valor_mercadoria || 0), 0);
    const totalFrete = aplicados.reduce((a,l) => a + Number(l.valor_frete || 0), 0);

    const rows = log.map(l => {
      const ehAuto = (l.executado_por || '').match(/^(etl_trigger|cron_diario)$/);
      const badge = l.modo === 'dry_run'
        ? '<span class="nd-badge cat">Preview</span>'
        : ehAuto
          ? `<span class="nd-badge ok">Auto · ${escapeHtml(l.executado_por)}</span>`
          : '<span class="nd-badge low">Manual</span>';
      return `
        <tr>
          <td class="nd-mono" style="font-size:12px">${fmtDateTime(l.executado_em)}</td>
          <td>${badge}</td>
          <td>${escapeHtml(l.executado_por || '—')}</td>
          <td class="num">${fmtNum(l.qtd_nfs)}</td>
          <td class="num" style="color:var(--zz-deep);font-weight:600">${fmtBRL(l.valor_mercadoria)}</td>
          <td class="num" style="color:var(--zz-slate)">${fmtBRL(l.valor_frete)}</td>
          <td style="font-size:12px;color:var(--zz-slate)">${escapeHtml(l.observacao || '')}</td>
        </tr>
      `;
    }).join('');

    $('#nd-hist-area').innerHTML = `
      <div class="nd-kpis" style="grid-template-columns:repeat(3,1fr)">
        <div class="nd-kpi hero">
          <div class="nd-kpi-label">Mercadoria já conciliada</div>
          <div class="nd-kpi-value accent">${fmtBRL(totalValor)}</div>
          <div class="nd-kpi-sub">${fmtNum(aplicados.length)} execuções aplicadas</div>
        </div>
        <div class="nd-kpi">
          <div class="nd-kpi-label">NFs baixadas</div>
          <div class="nd-kpi-value">${fmtNum(totalNfs)}</div>
          <div class="nd-kpi-sub">desde a primeira execução</div>
        </div>
        <div class="nd-kpi">
          <div class="nd-kpi-label">Frete conciliado</div>
          <div class="nd-kpi-value">${fmtBRL(totalFrete)}</div>
          <div class="nd-kpi-sub">receita confirmada</div>
        </div>
      </div>

      <div class="nd-section">
        <div class="nd-section-head">
          <div>
            <div class="nd-section-title">Execuções (mais recentes primeiro)</div>
            <div class="nd-section-sub">
              <strong>Auto · etl_trigger</strong>: roda a cada importação FAT_JC ·
              <strong>Auto · cron_diario</strong>: rede de segurança 06:30 BRT ·
              <strong>Manual</strong>: botão "Conciliar agora"
            </div>
          </div>
        </div>
        <div class="nd-section-body" style="overflow-x:auto">
          <table class="nd-table">
            <thead>
              <tr>
                <th>Quando</th>
                <th>Origem</th>
                <th>Executor</th>
                <th class="num">NFs</th>
                <th class="num">Mercadoria</th>
                <th class="num">Frete</th>
                <th>Observação</th>
              </tr>
            </thead>
            <tbody>
              ${rows || '<tr><td colspan="7" class="nd-empty">Nenhuma conciliação registrada.</td></tr>'}
            </tbody>
          </table>
        </div>
      </div>
    `;
  } catch (err) {
    $('#nd-hist-area').innerHTML = `<div class="nd-error">${escapeHtml(err.message || String(err))}</div>`;
  }
}

function renderEmConstrucao(titulo, descricao) {
  $('#nd-content').innerHTML = `
    <div class="nd-page-header">
      <div class="nd-page-eyebrow">Em construção</div>
      <h1 class="nd-page-title">${escapeHtml(titulo)}</h1>
      <div class="nd-page-sub">${escapeHtml(descricao)}</div>
    </div>
    <div class="nd-section">
      <div class="nd-empty">
        Este módulo será entregue em onda futura do roadmap NextDay.
      </div>
    </div>
  `;
}

// ─── Operação ao Vivo ─────────────────────────────────────
let _stateBucket = 'risco_real';   // 'risco_real' | 'a_conciliar_entregue' | null (todas)

async function renderOperacao() {
  const c = $('#nd-content');
  c.innerHTML = `
    <div class="nd-page-header">
      <div class="nd-page-eyebrow">Operação ao Vivo</div>
      <h1 class="nd-page-title">NFs em aberto sob custódia</h1>
      <div class="nd-page-sub">
        Cruzamento NF a NF com desfechos em outros períodos.
        <strong>Risco real</strong> = NFs em aberto sem nenhum registro de entrega ou devolução no banco.
      </div>
    </div>
    <div id="nd-kpis-area"><div class="nd-loading">Carregando KPIs…</div></div>
    <div id="nd-buckets-area"></div>
    <div id="nd-aging-area"></div>
    <div id="nd-table-area"></div>
  `;

  try {
    const kpis = await fetchKpis();
    renderKpis(kpis);
    renderBucketSwitcher(kpis);
    await renderTabelaPorBucket();
  } catch (err) {
    console.error(err);
    c.innerHTML += `<div class="nd-error">Erro ao carregar dados: ${escapeHtml(err.message || err)}</div>`;
  }
}

function renderKpis(k) {
  const podeConciliar = (k.qtd_a_conciliar_entregue || 0) > 0 || (k.qtd_a_conciliar_devolvida || 0) > 0;
  $('#nd-kpis-area').innerHTML = `
    <div class="nd-kpis">
      <div class="nd-kpi hero">
        <div class="nd-kpi-label">Risco real · mercadoria sob custódia</div>
        <div class="nd-kpi-value accent">${fmtBRL(k.valor_risco_real)}</div>
        <div class="nd-kpi-sub">${fmtNum(k.qtd_risco_real)} NFs sem desfecho em nenhum registro</div>
      </div>
      <div class="nd-kpi">
        <div class="nd-kpi-label">A conciliar · já entregue</div>
        <div class="nd-kpi-value" style="color:var(--zz-green)">${fmtBRL(k.valor_a_conciliar_entregue)}</div>
        <div class="nd-kpi-sub">${fmtNum(k.qtd_a_conciliar_entregue)} NFs · só falta dar baixa</div>
        ${podeConciliar ? `
          <button id="nd-btn-conciliar" class="nd-btn-mini" style="margin-top:10px">Conciliar agora →</button>
        ` : ''}
      </div>
      <div class="nd-kpi">
        <div class="nd-kpi-label">Crítico (&gt; 180 dias) no risco real</div>
        <div class="nd-kpi-value" style="color:var(--zz-red)">${fmtNum(k.qtd_risco_critico)}</div>
        <div class="nd-kpi-sub danger">${fmtBRL(k.valor_risco_critico)} em mercadoria</div>
      </div>
      <div class="nd-kpi">
        <div class="nd-kpi-label">Receita pendente · risco real</div>
        <div class="nd-kpi-value">${fmtBRL(k.frete_risco_real)}</div>
        <div class="nd-kpi-sub">frete emitido não recebido</div>
      </div>
    </div>
  `;
  if (podeConciliar) {
    $('#nd-btn-conciliar').addEventListener('click', abrirModalConciliacao);
  }
}

// ─── Modal de conciliação ─────────────────────────────────
async function abrirModalConciliacao() {
  // 1. Mostra loading do dry-run
  document.body.insertAdjacentHTML('beforeend', `
    <div id="nd-modal-overlay" class="nd-modal-overlay">
      <div class="nd-modal">
        <div class="nd-modal-head">
          <div>
            <div class="nd-page-eyebrow">Conciliação automática</div>
            <h2 class="nd-modal-title">Baixa de NFs em aberto com desfecho em outro registro</h2>
          </div>
          <button class="nd-modal-close" aria-label="Fechar">×</button>
        </div>
        <div class="nd-modal-body">
          <div class="nd-loading">Calculando preview…</div>
        </div>
      </div>
    </div>
  `);
  const overlay = $('#nd-modal-overlay');
  const close = () => overlay.remove();
  overlay.querySelector('.nd-modal-close').addEventListener('click', close);
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });

  let preview;
  try {
    preview = await reconciliarEmAberto({ dryRun: true });
  } catch (err) {
    overlay.querySelector('.nd-modal-body').innerHTML =
      `<div class="nd-error">${escapeHtml(err.message || String(err))}</div>`;
    return;
  }

  const detalhes = preview.detalhes || [];
  const linhas = detalhes.map(d => `
    <tr>
      <td class="nf-link">${escapeHtml(d.nf || '')}</td>
      <td class="num" style="font-weight:600">${fmtBRL(d.valor_nf)}</td>
      <td><span class="nd-badge med">${escapeHtml(d.status_old)}</span>
          → <span class="nd-badge ok">${escapeHtml(d.status_new)}</span></td>
      <td class="nd-mono" style="font-size:11px;color:var(--zz-slate)">${escapeHtml(d.ocor_new || '—')}</td>
      <td class="num">${fmtDate(d.data_entrega_nova || d.data_ocor_nova)}</td>
    </tr>
  `).join('');

  overlay.querySelector('.nd-modal-body').innerHTML = `
    <div style="background:rgba(26,179,109,0.06);border:1px solid rgba(26,179,109,0.30);border-radius:10px;padding:14px 18px;margin-bottom:18px">
      <div style="font-size:13px;color:var(--zz-success);font-weight:600">
        ${fmtNum(preview.qtd_nfs)} NFs serão baixadas
      </div>
      <div style="font-size:12px;color:var(--zz-slate);margin-top:4px">
        Mercadoria conciliada: <strong>${fmtBRL(preview.valor_mercadoria)}</strong> ·
        Frete: <strong>${fmtBRL(preview.valor_frete)}</strong>
      </div>
    </div>
    <div style="overflow-x:auto;margin-bottom:18px">
      <table class="nd-table">
        <thead>
          <tr>
            <th>NF</th>
            <th class="num">Mercadoria</th>
            <th>Status (antes → depois)</th>
            <th>Ocorrência detectada</th>
            <th class="num">Data desfecho</th>
          </tr>
        </thead>
        <tbody>${linhas || '<tr><td colspan="5" class="nd-empty">Nada a conciliar.</td></tr>'}</tbody>
      </table>
    </div>
    <div class="nd-modal-foot">
      <button id="nd-cancel" class="nd-btn-ghost">Cancelar</button>
      <button id="nd-aplicar" class="nd-btn" ${preview.qtd_nfs ? '' : 'disabled'}>
        Aplicar baixa em ${fmtNum(preview.qtd_nfs)} NF${preview.qtd_nfs===1?'':'s'}
      </button>
    </div>
  `;
  $('#nd-cancel').addEventListener('click', close);
  $('#nd-aplicar').addEventListener('click', async () => {
    $('#nd-aplicar').disabled = true;
    $('#nd-aplicar').textContent = 'Aplicando…';
    try {
      const result = await reconciliarEmAberto({ dryRun: false });
      overlay.querySelector('.nd-modal-body').innerHTML = `
        <div style="background:rgba(26,179,109,0.06);border:1px solid rgba(26,179,109,0.30);border-radius:10px;padding:18px 20px;text-align:center">
          <div style="font-size:14px;font-weight:600;color:var(--zz-success)">Conciliação aplicada</div>
          <div style="font-size:13px;color:var(--zz-slate);margin-top:6px">
            ${fmtNum(result.qtd_nfs)} NFs baixadas · ${fmtBRL(result.valor_mercadoria)} em mercadoria conciliados
          </div>
          <div style="font-size:11px;color:var(--zz-slate-2);margin-top:10px">log #${result.log_id}</div>
        </div>
        <div class="nd-modal-foot" style="justify-content:center;margin-top:18px">
          <button id="nd-ok" class="nd-btn">Atualizar dashboard</button>
        </div>
      `;
      $('#nd-ok').addEventListener('click', () => { close(); renderOperacao(); });
    } catch (err) {
      $('#nd-aplicar').textContent = 'Erro — tentar de novo';
      $('#nd-aplicar').disabled = false;
      overlay.querySelector('.nd-modal-body').insertAdjacentHTML(
        'afterbegin', `<div class="nd-error">${escapeHtml(err.message || String(err))}</div>`);
    }
  });
}

function renderBucketSwitcher(k) {
  $('#nd-buckets-area').innerHTML = `
    <div class="nd-section" style="margin-bottom:16px">
      <div class="nd-section-head" style="padding:14px 20px">
        <div style="display:flex;gap:8px;flex-wrap:wrap">
          <button class="nd-tab ${_stateBucket==='risco_real' ? 'active' : ''}" data-bucket="risco_real">
            Risco real <span class="nd-tab-count">${fmtNum(k.qtd_risco_real)}</span>
          </button>
          <button class="nd-tab ${_stateBucket==='a_conciliar_entregue' ? 'active' : ''}" data-bucket="a_conciliar_entregue">
            A conciliar (entregue) <span class="nd-tab-count">${fmtNum(k.qtd_a_conciliar_entregue)}</span>
          </button>
          <button class="nd-tab ${_stateBucket===null ? 'active' : ''}" data-bucket="todas">
            Todas <span class="nd-tab-count">${fmtNum(k.qtd_total)}</span>
          </button>
        </div>
      </div>
    </div>
  `;
  document.querySelectorAll('.nd-tab').forEach(b => {
    b.addEventListener('click', async () => {
      const v = b.dataset.bucket;
      _stateBucket = (v === 'todas') ? null : v;
      document.querySelectorAll('.nd-tab').forEach(x => x.classList.toggle('active', x === b));
      await renderTabelaPorBucket();
    });
  });
}

async function renderTabelaPorBucket() {
  $('#nd-aging-area').innerHTML = '<div class="nd-loading">Carregando…</div>';
  $('#nd-table-area').innerHTML = '';
  const nfs = await fetchNfsEmAberto(_stateBucket ? { bucket: _stateBucket } : {});
  renderAging(nfs);
  renderTabela(nfs);
}

const ORDEM_AGING = [
  { key: '> 180 dias (CRÍTICO)',    cls: 'crit', label: '> 180 dias',     sub: 'Crítico' },
  { key: '91 a 180 dias (ALTO)',    cls: 'high', label: '91–180 dias',    sub: 'Alto' },
  { key: '31 a 90 dias (MÉDIO)',    cls: 'med',  label: '31–90 dias',     sub: 'Médio' },
  { key: '8 a 30 dias (BAIXO)',     cls: '',     label: '8–30 dias',      sub: 'Baixo' },
  { key: '0 a 7 dias (RECENTE)',    cls: '',     label: '0–7 dias',       sub: 'Recente' },
];

function renderAging(nfs) {
  const buckets = {};
  for (const n of nfs) {
    const k = n.faixa_aging;
    if (!buckets[k]) buckets[k] = { qtd: 0, valor: 0 };
    buckets[k].qtd  += 1;
    buckets[k].valor += Number(n.valor_nf || 0);
  }
  const cells = ORDEM_AGING.map(r => {
    const b = buckets[r.key] || { qtd: 0, valor: 0 };
    return `
      <div class="nd-aging-cell ${r.cls}">
        <div class="nd-aging-cell-label">${r.label} · ${r.sub}</div>
        <div class="nd-aging-cell-value">${fmtNum(b.qtd)}</div>
        <div class="nd-aging-cell-sub">${fmtBRL(b.valor)}</div>
      </div>
    `;
  }).join('');

  $('#nd-aging-area').innerHTML = `
    <div class="nd-section">
      <div class="nd-section-head">
        <div>
          <div class="nd-section-title">Aging por valor de mercadoria</div>
          <div class="nd-section-sub">Distribuição do risco por tempo em aberto.</div>
        </div>
      </div>
      <div class="nd-aging-grid">${cells}</div>
    </div>
  `;
}

function bucketBadge(bucket) {
  if (bucket === 'a_conciliar_entregue') return '<span class="nd-badge ok">A baixar · entregue</span>';
  if (bucket === 'a_conciliar_devolvida') return '<span class="nd-badge med">A baixar · devolvida</span>';
  return '<span class="nd-badge crit">Risco real</span>';
}

function renderTabela(nfs) {
  const totalValor = nfs.reduce((a,n) => a + Number(n.valor_nf||0), 0);
  const totalFrete = nfs.reduce((a,n) => a + Number(n.frete||0), 0);
  const showCruz = nfs.some(n => n.bucket && n.bucket !== 'risco_real');

  const rows = nfs.map(n => `
    <tr>
      <td class="nf-link">${escapeHtml(n.nf || '')}</td>
      <td>${escapeHtml(n.destinatario || '')}</td>
      <td>${escapeHtml((n.cidade || '') + (n.uf ? '/' + n.uf : ''))}</td>
      <td>${bucketBadge(n.bucket)}</td>
      <td><span class="nd-badge cat">${escapeHtml(n.categoria || '')}</span></td>
      <td class="num" style="font-weight:600;color:${Number(n.valor_nf||0) >= 5000 ? 'var(--zz-red)' : 'var(--zz-deep)'}">
        ${fmtBRL(n.valor_nf)}
      </td>
      <td class="num">${fmtBRL(n.frete)}</td>
      <td class="center">${diasBadge(n.dias_aberto)}</td>
      <td class="num">${fmtDate(n.data_ultima_ocorrencia || n.data_frete)}</td>
      ${showCruz ? `<td>${
        n.bucket && n.bucket !== 'risco_real'
          ? `<span class="nd-mono" style="color:var(--zz-green);font-size:11px">
               ${fmtDate(n.data_entrega_outro_reg || n.data_ult_ocor_outro_reg)} · ${escapeHtml(n.ultima_ocor_outro_reg || '')}
             </span>`
          : '<span style="color:var(--zz-slate-2)">—</span>'
      }</td>` : ''}
    </tr>
  `).join('');

  const titulo = _stateBucket === 'risco_real'
    ? `Risco real — ${nfs.length} NFs sob custódia sem desfecho`
    : _stateBucket === 'a_conciliar_entregue'
    ? `A conciliar — ${nfs.length} NFs já entregues em outro registro`
    : `Todas as NFs em aberto — ${nfs.length}`;

  $('#nd-table-area').innerHTML = `
    <div class="nd-section">
      <div class="nd-section-head">
        <div>
          <div class="nd-section-title">${titulo}</div>
          <div class="nd-section-sub">
            Ordenado por valor da mercadoria. Mercadoria total: <strong>${fmtBRL(totalValor)}</strong> ·
            Frete: <strong>${fmtBRL(totalFrete)}</strong>
          </div>
        </div>
      </div>
      <div class="nd-section-body" style="overflow-x:auto">
        <table class="nd-table">
          <thead>
            <tr>
              <th>NF</th>
              <th>Destinatário</th>
              <th>Cidade</th>
              <th>Status</th>
              <th>Categoria</th>
              <th class="num">Valor mercadoria</th>
              <th class="num">Frete</th>
              <th class="center">Aging</th>
              <th class="num">Última ocorrência</th>
              ${showCruz ? '<th>Desfecho em outro registro</th>' : ''}
            </tr>
          </thead>
          <tbody>
            ${rows || '<tr><td colspan="10" class="nd-empty">Nenhuma NF nesta categoria.</td></tr>'}
          </tbody>
        </table>
      </div>
    </div>
  `;
}

// ─── Fechamento Mensal ────────────────────────────────────
const _fech = {
  mes: defaultMes(),
  he: 148.61,
  km: 5043.9,
  obs: '',
  preview: null,
  salvo: null,
  carregando: false,
};

function defaultMes() {
  const d = new Date();
  d.setDate(1); d.setMonth(d.getMonth() - 1);
  return d.toISOString().slice(0, 10);
}

function mesesDisponiveis() {
  const out = [];
  const inicio = new Date('2025-01-01');
  const hoje = new Date();
  hoje.setDate(1);
  for (let d = new Date(hoje); d >= inicio; d.setMonth(d.getMonth() - 1)) {
    out.push(new Date(d).toISOString().slice(0, 10));
  }
  return out;
}

const MESES_PT = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
function fmtMes(s) {
  const d = new Date(s + 'T00:00:00');
  return `${MESES_PT[d.getMonth()]} ${d.getFullYear()}`;
}

async function renderFechamento() {
  $('#nd-content').innerHTML = `
    <div class="nd-page-header">
      <div class="nd-page-eyebrow">Onda 2 · Fechamento Mensal</div>
      <h1 class="nd-page-title">Fechamento contratual NextDay</h1>
      <div class="nd-page-sub">
        Cálculo automático: Custo Fixo + HE + KM + Reentregas + Diesel + ICMS/ISS → Carta de Crédito.
        Aprovação trava o snapshot com hash imutável.
      </div>
    </div>
    <div id="nd-fech-area"><div class="nd-loading">Carregando fechamentos…</div></div>
  `;
  await renderFechamentoUI();
}

async function renderFechamentoUI() {
  const fechamentos = await fetchFechamentos({ limit: 24 });
  const salvo = fechamentos.find(f => f.mes === _fech.mes);
  _fech.salvo = salvo || null;
  if (salvo) {
    _fech.he = salvo.inputs?.he_horas ?? _fech.he;
    _fech.km = salvo.inputs?.km_excedente ?? _fech.km;
    _fech.obs = salvo.observacao || '';
  }
  const aprovado = salvo?.status === 'aprovado';
  const meses = mesesDisponiveis();
  const optsMes = meses.map(m => `
    <option value="${m}" ${m === _fech.mes ? 'selected' : ''}>${fmtMes(m)}</option>
  `).join('');

  const tabelaHist = fechamentos.length === 0
    ? '<tr><td colspan="6" class="nd-empty">Nenhum fechamento registrado ainda.</td></tr>'
    : fechamentos.map(f => `
        <tr>
          <td><a href="#" class="nf-link" data-mes="${f.mes}">${fmtMes(f.mes)}</a></td>
          <td>${f.status === 'aprovado'
                ? '<span class="nd-badge ok">Aprovado</span>'
                : '<span class="nd-badge low">Rascunho</span>'}</td>
          <td class="num">${fmtBRL(f.calculo?.total_a_faturar)}</td>
          <td class="num">${fmtBRL(f.calculo?.carta_credito?.a_faturar)}</td>
          <td class="nd-mono" style="font-size:11px">${f.hash_sha256 ? f.hash_sha256.substring(0,12) + '…' : '—'}</td>
          <td class="nd-mono" style="font-size:11px;color:var(--zz-muted)">${fmtDateTime(f.aprovado_em || f.atualizado_em)}</td>
        </tr>
      `).join('');

  $('#nd-fech-area').innerHTML = `
    <div class="nd-section">
      <div class="nd-section-head">
        <div>
          <div class="nd-section-title">Configuração do mês</div>
          <div class="nd-section-sub">Selecione o mês e informe as horas extras totais e km excedente.</div>
        </div>
        ${aprovado ? `<span class="nd-badge ok">Aprovado · hash ${salvo.hash_sha256.substring(0,8)}</span>` : ''}
      </div>
      <div class="nd-form-grid">
        <label>
          <span>Mês de competência</span>
          <select id="fech-mes" ${aprovado ? 'disabled' : ''}>${optsMes}</select>
        </label>
        <label>
          <span>Horas extras totais (h)</span>
          <input type="number" step="0.01" id="fech-he" value="${_fech.he}" ${aprovado ? 'disabled' : ''} />
        </label>
        <label>
          <span>Km excedente (km)</span>
          <input type="number" step="0.1" id="fech-km" value="${_fech.km}" ${aprovado ? 'disabled' : ''} />
        </label>
        <div class="nd-form-actions">
          <button id="fech-calc" class="nd-btn-ghost" ${aprovado ? 'disabled' : ''}>Calcular preview</button>
          <button id="fech-save" class="nd-btn-ghost" ${aprovado ? 'disabled' : ''}>Salvar rascunho</button>
          <button id="fech-aprovar" class="nd-btn" ${aprovado ? 'disabled' : ''}>Aprovar e travar</button>
        </div>
      </div>
    </div>

    <div id="nd-fech-preview"></div>

    <div class="nd-section" style="margin-top:24px">
      <div class="nd-section-head">
        <div>
          <div class="nd-section-title">Histórico de fechamentos</div>
          <div class="nd-section-sub">Clique no mês para abrir.</div>
        </div>
      </div>
      <div class="nd-section-body" style="overflow-x:auto">
        <table class="nd-table">
          <thead>
            <tr>
              <th>Mês</th><th>Status</th>
              <th class="num">Total a faturar</th><th class="num">Carta de crédito</th>
              <th>Hash</th><th>Última atualização</th>
            </tr>
          </thead>
          <tbody>${tabelaHist}</tbody>
        </table>
      </div>
    </div>
  `;

  // Listeners
  $('#fech-mes').addEventListener('change', async e => {
    _fech.mes = e.target.value;
    _fech.preview = null;
    await renderFechamentoUI();
  });
  $('#fech-he').addEventListener('input', e => { _fech.he = Number(e.target.value) || 0; });
  $('#fech-km').addEventListener('input', e => { _fech.km = Number(e.target.value) || 0; });
  $('#fech-calc').addEventListener('click',  () => doFechCalc(false));
  $('#fech-save').addEventListener('click',  () => doFechSalvar(false));
  $('#fech-aprovar').addEventListener('click', () => doFechSalvar(true));
  document.querySelectorAll('a[data-mes]').forEach(a => a.addEventListener('click', async ev => {
    ev.preventDefault();
    _fech.mes = a.dataset.mes;
    _fech.preview = null;
    await renderFechamentoUI();
  }));

  // Se já existe salvo, mostra o preview com o cálculo persistido
  if (salvo?.calculo) {
    _fech.preview = salvo.calculo;
    renderFechPreview(salvo.calculo, { hashShort: salvo.hash_sha256?.substring(0,12) });
  }
}

async function doFechCalc(silent = false) {
  if (!silent) $('#nd-fech-preview').innerHTML = '<div class="nd-loading">Calculando…</div>';
  try {
    const calc = await calcularFechamento({
      mes: _fech.mes, heHoras: _fech.he, kmExcedente: _fech.km,
    });
    _fech.preview = calc;
    renderFechPreview(calc, { previewLive: true });
  } catch (err) {
    $('#nd-fech-preview').innerHTML = `<div class="nd-error">${escapeHtml(err.message || String(err))}</div>`;
  }
}

async function doFechSalvar(aprovar) {
  const verbo = aprovar ? 'aprovação (vai travar — irreversível)' : 'salvar como rascunho';
  if (!confirm(`Confirmar ${verbo} para ${fmtMes(_fech.mes)}?`)) return;
  try {
    const result = await salvarFechamento({
      mes: _fech.mes, heHoras: _fech.he, kmExcedente: _fech.km,
      aprovar, observacao: _fech.obs || null,
    });
    _fech.preview = result.calculo;
    await renderFechamentoUI();
  } catch (err) {
    alert('Erro: ' + (err.message || String(err)));
  }
}

function renderFechPreview(c, opts = {}) {
  const nd = c.next_day, re = c.reentregas, ic = c.intercorrencias, im = c.impostos, cc = c.carta_credito, p = c.parametros;
  const pct = v => (v * 100).toFixed(2) + '%';
  $('#nd-fech-preview').innerHTML = `
    <div class="nd-section" style="margin-top:18px">
      <div class="nd-section-head">
        <div>
          <div class="nd-section-title">Preview · ${fmtMes(c.mes + '-01')}</div>
          <div class="nd-section-sub">
            Reajuste contratual <strong>${pct(p.pct_reajuste_contratual)}</strong> ·
            Diesel <strong>${pct(p.pct_reajuste_diesel)}</strong> ·
            Reentrega <strong>${pct(p.pct_reentrega_sp)}</strong> da Super Rápida
            ${opts.hashShort ? ` · hash <span class="nd-mono">${opts.hashShort}</span>` : ''}
            ${opts.previewLive ? ` · <em style="color:var(--zz-blue-deep)">preview ao vivo (não salvo)</em>` : ''}
          </div>
        </div>
      </div>
      <div class="nd-section-body" style="padding:18px 20px">
        ${blocoFech('1. Operação NextDay (frota dedicada)', [
          ['Custo fixo mensal (8 veículos)', `237.600 × (1 + ${pct(p.pct_reajuste_contratual)})`, nd.custo_fixo_aplicado],
          ['Horas extras', `${fmtNum(c.inputs.he_horas, 2)}h × ${fmtBRL(nd.hora_extra_unit)}`, nd.hora_extra_valor],
          ['Km excedente', `${fmtNum(c.inputs.km_excedente, 1)} km × ${fmtBRL(nd.km_unit)}`, nd.km_valor],
          ['Subtotal Next Day', 'Custo fixo + HE + Km', nd.subtotal, 'sub'],
          ['Reajuste Diesel sobre Next Day', `Subtotal × ${pct(p.pct_reajuste_diesel)}`, nd.diesel],
          ['TOTAL NEXT DAY', '', nd.total, 'total'],
        ])}
        ${blocoFech('2. Reentregas SP', [
          ['Frete Reentrega', `${re.qtd_nfs} NFs · ${fmtNum(re.m3_total,3)} m³ × ${pct(p.pct_reentrega_sp)} Super Rápida`, re.bruto],
          ['Reajuste Diesel sobre Reentregas', `Bruto × ${pct(p.pct_reajuste_diesel)}`, re.diesel],
          ['TOTAL REENTREGAS', '', re.total, 'total'],
        ])}
        ${ic.qtd > 0 ? blocoFech('3. Cobrança Extra Intercorrências', [
          [`${ic.qtd} NFs com >1 intercorrência`, '(Qtd-1) × valor reentrega', ic.valor, 'total'],
        ]) : ''}
        ${blocoFech('Total a faturar (subtotal contratual)', [
          ['Operação NextDay + Reentregas + Intercorrências', '', c.total_a_faturar, 'total-blue'],
        ])}
        ${blocoFech('Impostos retidos nos CT-e (ressarcidos via carta)', [
          ['ICMS retido', 'Modal rodoviário interestadual', im.icms_retido],
          ['ISS retido',  'Serviço municipal',              im.iss_retido],
          ['TOTAL IMPOSTO RETIDO', '', im.total, 'total'],
        ])}
        ${blocoFech('Carta de Crédito (residual a faturar)', [
          ['(+) Total Faturamento Contratual', '', cc.total_contratual],
          ['(+) Impostos Retidos',             '', cc.imposto_retido],
          ['(=) Total Bruto Contratual',       '', cc.bruto_contratual, 'sub'],
          ['(−) Frete já emitido via CT-e/NF', '', -cc.frete_ja_emitido],
          ['TOTAL CARTA DE CRÉDITO', '', cc.a_faturar, 'total-blue'],
        ])}
      </div>
    </div>
  `;
}

function blocoFech(titulo, linhas) {
  return `
    <div class="nd-fech-bloco">
      <div class="nd-fech-bloco-titulo">${escapeHtml(titulo)}</div>
      <table class="nd-table" style="margin-bottom:8px">
        <tbody>
          ${linhas.map(([rotulo, base, valor, kind]) => `
            <tr class="${kind || ''}">
              <td style="width:42%">${escapeHtml(rotulo)}</td>
              <td style="width:38%;font-size:12px;color:var(--zz-muted)">${escapeHtml(base || '')}</td>
              <td class="num" style="width:20%">${fmtBRL(valor)}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    </div>
  `;
}

boot();
